<template>
  <div class="guide-step-3-container" v-if="isVisible">
    <!-- 確定按鈕引導箭頭 -->
    <div class="guide-confirm-button">
      <div class="guide-arrow-left">
        <svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 12L38 12M2 12L12 2M2 12L12 22" stroke="#F59E0B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="guide-tip">
        {{ t('gameActManager.gameActGuide.step3.confirmButton') }}
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted, defineExpose, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

// Props - 接收活動數量
const props = defineProps({
  activityCount: {
    type: Number,
    default: 0
  }
});

const isVisible = ref(false);

// 檢查是否需要顯示引導
const checkGuideStatus = () => {
  const guideStep = localStorage.getItem('hasSeenGameActivityGuideStep');
  // 如果完成了步驟2，但未完成步驟3，且活動數量 ≤ 1，則顯示
  if (guideStep === 'step2' && props.activityCount <= 1) {
    isVisible.value = true;
  }
};

// 隱藏引導（當使用者點擊「確定」按鈕時調用）
const hideGuide = () => {
  isVisible.value = false;
  // 記錄使用者已看過步驟 3
  localStorage.setItem('hasSeenGameActivityGuideStep', 'step3');
};

// 暴露方法給父組件使用
defineExpose({
  hideGuide
});

onMounted(() => {
  checkGuideStatus();
});
</script>

<style lang="less" scoped>
.guide-step-3-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  pointer-events: none;
}

.guide-confirm-button {
  position: absolute;
  bottom: 20px;
  right: -200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  animation: fade-in 0.3s ease-out;
  pointer-events: none;
}

.guide-arrow-left {
  svg {
    animation: bounce-horizontal-left 1.5s ease-in-out infinite;
  }
}

.guide-tip {
  background-color: rgba(255, 255, 255, 0.95);
  padding: 10px 16px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  line-height: 1.6;
  white-space: nowrap;
  text-align: center;
}

// 動畫定義
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes bounce-horizontal-left {
  0%, 100% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(-8px);
  }
}

// 響應式設計
@media (max-width: 768px) {
  .guide-confirm-button {
    bottom: 80px;
    right: 300px;
  }

  .guide-tip {
    font-size: 13px;
    padding: 8px 12px;
  }
}
</style>
